import React, { useState } from "react";
import { ourFounderStory } from "../../utils/constants/Team";
import Fade from "react-reveal/Fade";
import CustomReadMore from "../common/CustomReadMore";
import CustomNextImage from "../common/CustomNextImage";

const OurFounders = () => {
  const [readMore, setReadMore] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const ourFounders = [
    {
      name: "Keertay Agarwal",
      role: "Founder & COO",
      style: "bottom-[25%] left-[3%]  md:left-[6%]",
    },
    {
      name: "Rohit Choudhary",
      role: "Founder & CEO",
      style: "bottom-[10%] left-[37%] md:left-[41.5%]",
    },
    {
      name: "Yash Banwani",
      role: "Founder & CTO",
      style: "bottom-[25%] right-[3%] md:right-[6%]",
    },
  ];

  // Toggle ReadMore
  const handleToggleReadMore = (index) => {
    setReadMore((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] font-lexend font-semibold text-center lg:text-[40px]">
          Meet Our Founders
        </h6>
      </Fade>

      <div className="flex flex-col justify-center gap-6 mt-8 border border-[#3a3a3a] p-5 rounded-2xl bg-[#141414] text-[#b8b8b8] lg:flex-row">
        <div className="!relative w-full rounded-2xl lg:w-1/2">
          <div className="overflow-hidden rounded-2xl">
            <CustomNextImage
              src="/assets/teams/our-founders/our-founders.webp"
              alt="Meet Our Founders"
              width={1000}
              height={1000}
              className="object-cover w-full h-auto rounded-2xl transform transition-transform duration-300 ease-in-out hover:scale-105"
            />
          </div>
          {ourFounders?.map((item) => {
            return (
              <div
                key={item?.name}
                className={`absolute font-lexend border-[.5px] bg-black/30 border-[#a0a0aa] backdrop-blur-sm text-[8px] leading-[10px] font-semibold text-white px-1.5 py-1 text-center w-fit rounded-lg md:p-2 md:text-[14px] md:leading-[18px] ${item?.style}`}
              >
                <span>{item?.name}</span>
                <br />
                <span className="text-[8px] font-lexend leading-[8px] text-[#ebebeb] font-normal md:text-[12px]">
                  {item?.role}
                </span>
              </div>
            );
          })}
        </div>
        <div
          className="hidden relative w-[full] max-h-[387px] overflow-hidden rounded-lg p-4 lg:block lg:w-1/2 lg:pl-8"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div
            id="HideScroll"
            className={`overflow-y-auto pr-2 max-h-[387px] transition-transform duration-1000 ease-in-out ${
              isHovered ? "animate-scroll-up" : ""
            }`}
          >
            {ourFounderStory.map((para, i) => (
              <p
                key={i}
                className="mb-4 text-[16px] leading-[24px] !font-lexend text-[#b8b8b8]"
              >
                {para}
              </p>
            ))}
          </div>

          {/* Fading Overlay */}
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#141414] pointer-events-none" />
        </div>
        <div
          className={`w-[full] ${
            readMore ? "h-auto" : "max-h-[187px]"
          } lg:hidden`}
        >
          <CustomReadMore
            readMore={readMore}
            index="founderStory"
            displayText={ourFounderStory}
            className="!text-[#b8b8b8] !text-[12px] !font-lexend"
            handleToggleReadMore={() => handleToggleReadMore("founderStory")}
          />
        </div>
      </div>
    </section>
  );
};

export default OurFounders;
